//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkAuthor } from '@/utils/utils'
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        long: false
      }
    },
    computed: {
      authors () {
        return (this.item.authors || []).join(', ')
      }
    },
    mounted() {
      if(this.item.width / this.item.height > 1.666 || this.item.isKit && this.item.positional === 'horizontal') {
        this.long = true
      }
    },
    methods: {
      checkVerification(item, author) {
        return checkAuthor(item, author)
      },
    }
  }
